module.exports = __webpack_public_path__ + "media/images/card-background-list-ebfee4de161394c2d19b887ca364b665.svg";